/*
 * Seeds
 *
 * Use this file to populate an empty Firestore or reset the content
 * of the Firestore.
 */
import seed from './MSU-Facilities-and-Land-Use-Plan-seed.json'


const seeds = {
    en: seed
}


export default seeds;
